module.exports = __webpack_public_path__ + "img/drone_05_H.b9856799.webp";